export default {
  RETURN_PRODUCT: {
    TITLE: 'Return & Exchange',
    CONTENT1: `<p>Pengembalian dan penukaran produk dapat diproses melalui whatsapp resmi kami di : 
    <br/>+622732837827382 atau klik pada tombol whatsapp. 
    <br/><br/>
    Penukaran bisa diajukan jika memenuhi beberapa kriteria seperti berikut ini:
    </p>
    <ul>
        <li><strong>Produk masih segel, belum dipakai dan dicuci.</strong></li>
        <li><strong>Produk masih dalam kondisi utuh.</strong></li>
        <li><strong>Produk memilki cacat tidak sesuai standard.</strong></li>
        <li><strong>Produk dalam keadaan vacuum terbuka/kempis.</strong></li>
        <li><strong>Tidak melebihi batas waktu H+7 setelah produk sampai pada customer.</strong></li>
        <li><strong>Kesalahan produk tidak sesuai dengan pesanan.</strong></li>
        <li><strong>Pembelian tidak mengikuti sale product defect/cacat.</strong></li>
    </ul>
    <p>Program ini hanya berlaku untuk pembelian langsung pada website resmi kami, 
    <br/>jika ada keluhan pada produk yang dibeli ditempat lain silahkan menghubungi kepada pihak penjual/reseller yang bersangkutan</p>
    `
  }
}
